<!--  -->
<template>
  <div> 
    <el-row>
                     <el-col :span="4">
                       <div class="grid-content">H：</div>
                     </el-col>
                     <el-col :span="8">
                       <div class="grid-content">
                         <el-input              
                        ref="ParallelogramBChildInput1"
                        @keyup.enter.native="focusNextChild('ParallelogramBChildInput2')"  v-model="param.H" @focus="handleChildFocus"   @change="ChangData"  placeholder="请输入参数H"></el-input>
                       </div>
                     </el-col>
                     <el-col :span="4">
                       <div class="grid-content">W：</div>
                     </el-col>
                     <el-col :span="8">
                       <div class="grid-content">
                         <el-input              
                        ref="ParallelogramBChildInput2"
                        @keyup.enter.native="focusNextChild('ParallelogramBChildInput3')" v-model="param.W" @focus="handleChildFocus"   @change="ChangData"  placeholder="请输入参数W"></el-input>
                       </div>
                     </el-col>
   </el-row>
    <el-row>
                     <el-col :span="4">
                       <div class="grid-content">W1：</div>
                     </el-col>
                     <el-col :span="8">
                       <div class="grid-content">
                         <el-input              
                        ref="ParallelogramBChildInput3"
                        @keyup.enter.native="focusNextChild('ParallelogramBChildInput4')" v-model="param.W1" @focus="handleChildFocus"   @change="ChangData"  placeholder="请输入参数W1"></el-input>
                       </div>
                     </el-col>
                     <el-col :span="4">
                       <div class="grid-content">W2：</div>
                     </el-col>
                     <el-col :span="8">
                       <div class="grid-content">
                         <el-input              
                        ref="ParallelogramBChildInput4"
                        @keyup.enter.native="focusNextChild('ParallelogramBChildInput1')" v-model="param.W2" @focus="handleChildFocus"   @change="ChangData"  placeholder="请输入参数W2"></el-input>
                       </div>
                     </el-col>
   </el-row>
  </div>
   
 </template>
 
 <script>
 export default {
     name: "ParallelogramB",
   props: {},
   data () {
     return {
      param:{
        shapeName:"ParallelogramB",
      H:0,
      W:0,
      W1:0,
      W2:0,
    }
     };
   },
  methods:{
    ChangData(){
      console.log('The message is changed.',this.param);
      this.$emit("sedX",this.param)
    },
     // 处理焦点事件，选中文本并触发父组件监听
  handleChildFocus(event) {
   // console.log("handleChildFocus");
    setTimeout(() => {
        event.target.select();
      }, 0);
     // this.$emit('focused',event); // 通知父组件输入框被聚焦了。
    },
    focusNextChild(nextInputRef) {
      console.log("nextInputRef==",nextInputRef);
      this.$nextTick(() => {
        this.$refs[nextInputRef].focus(); // 使用Vue的$refs来聚焦到下一个输入框
      });
    },
  }
 }
 
 </script>
 <style lang='scss' scoped>
 </style>